var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",class:_vm.getSize(_vm.size)},[_c('img',{class:[_vm.getClasses(_vm.shadow, _vm.circular, _vm.borderRadius)],attrs:{"src":_vm.img,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }